import { config } from "@active-offsite/offsite.config";

/**
 * Anzeigename eines Teams. Feste Teams können abweichend heißen
 * (festeTeamLabels, netzwirtschaft: "Team 4a" statt "Team 4") — überall
 * sonst bleibt es "Team n". Bewusst eine Funktion statt Hook: Die Labels
 * stehen build-zeitlich in der Offsite-Config und ändern sich nie.
 */
export function teamLabel(n: number): string {
  return config.festeTeamLabels?.[n - 1] ?? `Team ${n}`;
}
